// extracted by mini-css-extract-plugin
export default {"tagsPopover":"TagsPopover--tagsPopover--UJxPK","tag":"TagsPopover--tag--bxVXK"};